module.exports = __webpack_public_path__ + "static/assets/5249e84a93ba545f590be083c00e0c09.svg";